import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { RecoilRoot } from 'recoil';
import RecoilNexus from 'recoil-nexus';
import { createRoot } from 'react-dom/client';
import { Honeybadger } from '@honeybadger-io/react';

import App from './App';
import { UIContextProvider } from './lib/context/UIContext/UIContextProvider';

if (typeof Promise.withResolvers !== 'function') {
  Promise.withResolvers = function () {
    let resolve;
    let reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

const honeyBadgerConfig = {
  apiKey: process.env.REACT_APP_HONEYBADGER_API_KEY,
  environment: process.env.ENV,
  revision: process.env.REACT_APP_GIT_SHA,
  tags: 'frontend'
};

Honeybadger.configure(honeyBadgerConfig);

const root = createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <RecoilRoot>
      <RecoilNexus />
      <UIContextProvider>
        <App />
      </UIContextProvider>
    </RecoilRoot>
  </BrowserRouter>
);
